'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { createContext, useState, useEffect, useContext } from 'react';
import { getCookieConsentValue } from 'react-cookie-consent';
import { startTracking, stopTracking } from '../utils/gtag';

interface CookiesContextType {
  // null = consent not read yet (server render and first client render).
  enabledCookies: { tracking: boolean | null; functional: boolean; personal: boolean };
  handleTrackingCookieConsent: (accepted: boolean) => void;
}

const CookiesContext = createContext<CookiesContextType | undefined>(undefined);

function CookiesContextProvider({ children }) {
  // Reading the consent cookie during render made the client differ from the server render
  // (hydration error #418/#423), so React re-rendered the whole page client-side.
  const [enabledCookies, setEnabledCookies] = useState<CookiesContextType['enabledCookies']>({
    tracking: null,
    functional: true, // hardcoded atm, for future purpose
    personal: true, // hardcoded atm, for future purpose
  });

  useEffect(() => {
    setEnabledCookies((prev) => ({ ...prev, tracking: getCookieConsentValue() === 'true' }));
  }, []);

  useEffect(() => {
    // Don't stop tracking (which removes the GA cookies) before the consent has been read.
    if (enabledCookies.tracking === null) return;
    if (enabledCookies.tracking) startTracking();
    else stopTracking();
  }, [enabledCookies.tracking]);

  function handleTrackingCookieConsent(accepted: boolean) {
    setEnabledCookies((prev) => ({ ...prev, tracking: accepted }));
  }

  return <CookiesContext.Provider value={{ enabledCookies, handleTrackingCookieConsent }}>{children}</CookiesContext.Provider>;
}

function useCookies() {
  const context = useContext(CookiesContext);
  if (context === undefined) throw new Error('useCookies must be used within a CookiesContextProvider');

  return context;
}

export { useCookies };
export default CookiesContextProvider;
